"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebAppDataManager = void 0;
const generateViewFromReport_1 = __importDefault(require("@opsbase/lib-data-view/helpers/generateViewFromReport"));
const useSelf_1 = __importDefault(require("@opsbase/react-ctrl-self/useSelf"));
const useReports_1 = __importDefault(require("@opsbase/react-gql-hooks/report/useReports"));
const useViewRegistryActions_1 = __importDefault(require("@opsbase/web-ctrl-view/useViewRegistryActions"));
const react_1 = require("react");
function WebAppDataManager(props) {
    const { children } = props;
    const self = (0, useSelf_1.default)();
    const { loading, data: reports, refetch } = (0, useReports_1.default)();
    const { putView, clearNonSystemViews } = (0, useViewRegistryActions_1.default)();
    const skipTimeout = (0, react_1.useRef)();
    // When the self changes... trigger a LMSS/reports reload
    (0, react_1.useEffect)(() => {
        if (skipTimeout.current)
            clearTimeout(skipTimeout.current);
        skipTimeout.current = setTimeout(() => refetch === null || refetch === void 0 ? void 0 : refetch(), 500);
    }, [self, refetch]);
    // When the reports have reloaded, add them to State store
    (0, react_1.useEffect)(() => {
        if (!loading && reports) {
            clearNonSystemViews();
            const views = reports.map(report => (0, generateViewFromReport_1.default)(report));
            views.forEach(view => putView(view));
        }
    }, [clearNonSystemViews, loading, putView, reports]);
    return children;
}
exports.WebAppDataManager = WebAppDataManager;
exports.default = WebAppDataManager;
